export default "__VITE_ASSET__29e0EDPH__"